module.exports = __webpack_public_path__ + "static/img/Bar.3110a4e.png";